export const breedList = [
  { id: 1, name: "Affenpinscher", value: "Affenpinscher" },
];

export const genderList = [
  { name: "Female", value: "female" },
  { name: "Male", value: "male" },
  { name: "Unknown", value: "Unknown" },
];

export const genderListAll = [
  { name: "All", value: "all" },
  { name: "Female", value: "female" },
  { name: "Male", value: "male" },
];

export const yesNoList = [
  { name: "No", value: "false" },
  { name: "Yes", value: "true" },
];

export const yesNoValueList = [
  { name: "No", value: "No" },
  { name: "Yes", value: "Yes" },
];

export const typeAppointemnt = [
  { name: "Phone", value: "Phone" },
  { name: "Walk-in", value: "Walk-in" },
];

export const typeService = [
  { name: "Consultation", value: "Consultation" },
  { name: "Grooming", value: "Grooming" },
  { name: "Pet Boarding", value: "Pet Boarding" },
];

export const requestFilters = [
  { name: "All", value: "All" },
  { name: "Pending", value: "Pending" },
  { name: "Completed", value: "Completed" },
  { name: "Cancelled", value: "Cancelled" },
];

export const serviceTypes = [
  { name: "Consultation", value: "Consultation" },
  { name: "Grooming", value: "Grooming" },
  { name: "Lab Tests", value: "Lab Tests" },
  { name: "Radiology Tests", value: "Radiology Tests" },
  { name: "Surgery", value: "Surgery" },
  { name: "Vaccination", value: "Vaccination" },
  { name: "Others", value: "Others" },
];

export const serviceTypeWOSurgery = [
  { name: "Consultation", value: "Consultation" },
  { name: "Grooming", value: "Grooming" },
  { name: "Lab Tests", value: "Lab Tests" },
  { name: "Radiology Tests", value: "Radiology Tests" },
  // { name: "Surgery", value: "Surgery" },
  { name: "Vaccination", value: "Vaccination" },
  { name: "Others", value: "Others" },
];

export const bookingTypes = [
  { name: "Slot based", value: "Slot based" },
  { name: "Immediate", value: "Immediate" },
];

export const typeList = [
  { name: "Physical", value: "Physical" },
  { name: "Virtual", value: "Virtual" },
  { name: "Home Visit", value: "Home" },
];

export const petTypes = [
  { name: "Cat", value: "Cat" },
  { name: "Dog", value: "Dog" },
  { name: "Others", value: "Others" },
];

export const billingFilters = [
  { name: "All", value: "All" },
  { name: "Home Visit", value: "Home" },
  // { name: "Inpatient", value: "Inpatient" },
  { name: "Outpatient", value: "Physical" },
  { name: "Virtual", value: "Virtual" },
];

export const petAppntTypeList = [
  { name: "Inpatient", value: "Inpatient" },
  { name: "Outpatient", value: "Outpatient" },
];

export const typeListNew = [{ name: "Physical", value: "Physical" }];

export const clinicRolesList = [
  { name: "Admin", value: "Admin", apiValue: "AD" },
  { name: "Billing", value: "Billing", apiValue: "BL" },
  { name: "Front Desk", value: "Front Desk", apiValue: "RE" },
  { name: "Groomer", value: "Groomer", apiValue: "GR" },
  { name: "Inventory Manager", value: "Inventory Manager", apiValue: "INV" },
  {
    name: "Lab/Radiology Technician",
    value: "Lab/Radiology Technician",
    apiValue: "RD",
  },
  { name: "Pharmacist", value: "Pharmacist", apiValue: "PH" },
  {
    name: "Veterinary Technician/Nurse",
    value: "Veterinary Technician/Nurse",
    // apiValue: "TN",
    apiValue: "VET",
  },
];

export const accessList = [
  { name: "Admin", value: "Admin", apiValue: "AD" },
  { name: "Billing", value: "Billing", apiValue: "BL" },
  { name: "Pharmacy Technician", value: "Pharmacy Technician", apiValue: "PH" },
  { name: "Front Desk", value: "Front Desk", apiValue: "RE" },
  { name: "PRM", value: "PRM", apiValue: "PRM" },
  { name: "Vet", value: "Vet", apiValue: "VET" },
];

export const accessListOthers = [
  { name: "Admin", value: "Admin", apiValue: "AD" },
  { name: "Billing", value: "Billing", apiValue: "BL" },
  { name: "Pharmacy Technician", value: "Pharmacy Technician", apiValue: "PH" },
  { name: "Front Desk", value: "Front Desk", apiValue: "RE" },
];

export const petTypeList = [{ name: "Dog", value: "dog" }];

export const salutationList = [
  // { name: "Dr.", value: "Dr" },
  { name: "Mr.", value: "Mr" },
  { name: "Mrs.", value: "Mrs" },
  { name: "Ms.", value: "Ms" },
];

export const specialtyList = [
  { name: "Anesthesiology", value: "Anesthesiology" },
  { name: "Behavioral Medicine", value: "Behavioral Medicine" },
  { name: "Cardiology", value: "Cardiology" },
  { name: "Dentistry", value: "Dentistry" },
  { name: "Dermatology", value: "Dermatology" },
  { name: "Emergency and Critical Care", value: "Emergency and Critical Care" },
  {
    name: "Endocrinology and Metabolism",
    value: "Endocrinology and Metabolism",
  },
  { name: "Gastroenterology", value: "Gastroenterology" },
  { name: "General Medicine", value: "General Medicine" },
  { name: "Gynaecology", value: "Gynaecology" },
  { name: "Hematology/Immunology", value: "Hematology/Immunology" },
  { name: "Hepatology", value: "Hepatology" },
  { name: "Infectious Disease", value: "Infectious Disease" },
  { name: "Internal Medicine", value: "Internal Medicine" },
  { name: "Musculoskeletal", value: "Musculoskeletal" },
  { name: "Nephrology/Urology", value: "Nephrology/Urology" },
  { name: "Neurology", value: "Neurology" },
  { name: "Nutrition", value: "Nutrition" },
  { name: "Oncology", value: "Oncology" },
  { name: "Ophthalmology", value: "Ophthalmology" },
  { name: "Orthopedic", value: "Orthopedic" },
  { name: "Radiology", value: "Radiology" },
  { name: "Respiratory", value: "Respiratory" },
  { name: "Surgery", value: "Surgery" },
  { name: "Toxicology", value: "Toxicology" },
  { name: "Zoological Medicine", value: "Zoological Medicine" },
];

export const paymentSearchTypeList = [
  { name: "Pet Name", value: "pet-name" },
  { name: "Vet Name", value: "vet-name" },
];

export const dateFilterList = [
  { name: "Today", value: "today" },
  { name: "This Week", value: "this" },
];

export const medicalHistorySearchTypelist = [
  { name: "Condition", value: "condition" },
  { name: "Date", value: "date_range" },
];

export const dateFilterTodayLastWeek = [
  { name: "Today", value: "today" },
  { name: "Last week", value: "last" },
];

export const vetDropList = [{ name: "Vet Name", value: "vet-name" }];

export const appointDropList = [
  { name: "Pet Name", value: "pet-name" },
  { name: "Vet Name", value: "vet-name" },
  { name: "Order Id", value: "order-id" },
];

export const appointDropListProduct = [
  { name: "Order Id", value: "order-id" },
  { name: "Product Name", value: "product-name" },
  { name: "Vet Name", value: "vet-name" },
];
export const locationDropList = [
  { name: "Chennai", value: "chennai" },
  { name: "Delhi", value: "delhi" },
  { name: "Hydrabad", value: "hydrabad" },
  { name: "Jaipur", value: "jaipur" },
  { name: "Kolkata", value: "kolkata" },
  { name: "Mumbai", value: "mumbai" },
  { name: "Noida", value: "noida" },
  { name: "Raipur", value: "raipur" },
  { name: "Tamil Nadu", value: "tamil nadu" },
];

export const NeuteredList = [
  { name: "Intact", value: "Intact" },
  { name: "Neutered", value: "Neutered" },
  { name: "Spayed", value: "Spayed" },
  { name: "Unknown", value: "Unknown" },
];

export const reproductiveStatusMaleList = [
  { name: "Intact", value: "Intact" },
  { name: "Neutered", value: "Neutered" },
  { name: "Unknown", value: "Unknown" },
];

export const reproductiveStatusFemaleList = [
  { name: "Intact", value: "Intact" },
  { name: "Spayed", value: "Spayed" },
  { name: "Unknown", value: "Unknown" },
];

export const reproductiveStatusUnknownList = [
  { name: "Unknown", value: "Unknown" },
];

export const PaymentTypeList = [
  { name: "Advance Adjustment", value: "Advance Adjustment" },
  { name: "Cash", value: "cash" },
  { name: "Card", value: "card" },
  { name: "Net Banking", value: "netBanking" },
  { name: "UPI", value: "upi" },
];

export const RMVPaymentTypeList = [
  { name: "Advance Adjustment", value: "Advance Adjustment" },
  { name: "Anirudh (UPI)", value: "anirudhUPI" },
  { name: "Apoorva (UPI)", value: "apoorvaUPI" },
  { name: "Cash", value: "cash" },
  { name: "Card", value: "card" },
  { name: "H card", value: "hCard" },
  { name: "Net Banking", value: "netBanking" },
  { name: "UPI", value: "upi" },
  { name: "Y card", avlue: "yCard" },
];

export const UserPaymentTypeList = [
  { name: "Cash", value: "cash" },
  { name: "Card", value: "card" },
  { name: "Net Banking", value: "netBanking" },
  { name: "UPI", value: "upi" },
];

export const paymentStatusList = [
  { name: "All", value: "all" },
  { name: "Paid", value: "paid" },
  { name: "Unpaid", value: "unpaid" },
  { name: "Partially Paid", value: "partiallypaid" },
  { name: "Cancelled", value: "cancelled" },
];

export const paymentTypeList = [
  { name: "Appointment", value: "Appointment" },
  { name: "Point of Sale", value: "Point of Sale" },
];

export const paymentInvoiceTypeList = [
  { name: "Invoice", value: "Invoice" },
  { name: "Credit Note", value: "Credit Note" },
];

export const paymentFilters = [
  { name: "All", value: "all" },
  { name: "Paid", value: "Paid" },
  // { name: "Partially Paid", value: "Partially" },
  { name: "Unpaid", value: "Unpaid" },
];

export const payReportFilter = [
  { name: "All", value: "all" },
  { name: "Paid", value: "paid" },
  { name: "Unpaid", value: "unpaid" },
];

export const reportPaymentStatus = [
  { name: "Paid", value: "paid" },
  { name: "Unpaid", value: "unpaid" },
];

export const taskCategory = [
  { name: "Deworming", value: "Deworming" },
  { name: "Diagnostics", value: "Diagnostics" },
  { name: "Flea/Tick Treatment", value: "Flea & Tick Treatment" },
  { name: "Medication", value: "Medication" },
  { name: "Others", value: "Others" },
  { name: "Vaccination", value: "Vaccines" },
];

export const yesNoBoolList = [
  { name: "No", value: false },
  { name: "Yes", value: true },
];

export const statusBoolList = [
  { name: "Active", value: true },
  { name: "Inactive", value: false },
];

export const productCategoryList = [
  { name: "Accessories & Toys", value: "Accessories & Toys" },
  { name: "Deworming", value: "Deworming" },
  { name: "Diet", value: "Diet" },
  { name: "Cleaning Supplies", value: "Cleaning Supplies" },
  { name: "Flea & Tick Treatment", value: "Flea & Tick Treatment" },
  { name: "Fluid Therapy", value: "Fluid Therapy" },
  { name: "General Consumables", value: "General Consumables" },
  { name: "General Equipment", value: "General Equipment" },
  { name: "Grooming & Hygiene Care", value: "Grooming & Hygiene Care" },
  { name: "Lab Supplies", value: "Lab Supplies" },
  { name: "Lab Consumables", value: "Lab Consumables" },
  { name: "Lab Equipment", value: "Lab Equipment" },
  { name: "Medical equipment", value: "Medical equipment" },
  { name: "Medical Supplies", value: "Medical Supplies" },
  { name: "Medication", value: "Medication" },
  { name: "Mortuary", value: "Mortuary" },
  { name: "Nutrition and Supplements", value: "Nutrition and Supplements" },
  { name: "Office Supplies", value: "Office Supplies" },
  { name: "OTC Products", value: "OTC Products" },
  { name: "Other Parasite Treatment", value: "Other Parasite Treatment" },
  { name: "Pet Supplies", value: "Pet Supplies" },
  { name: "Surgical Supplies", value: "Surgical Supplies" },
  { name: "Vaccines", value: "Vaccines" },
];

export const drugScheduleList = [
  { name: "Schedule H", value: "Schedule H" },
  { name: "Schedule H1", value: "Schedule H1" },
  { name: "Schedule X", value: "Schedule X" },
  { name: "Schedule G", value: "Schedule G" },
  { name: "Schedule C / C1", value: "Schedule C / C1" },
  { name: "OTC & non-scheduled", value: "OTC & non-scheduled" },
  { name: "Non-drug / non-scheduled", value: "Non-drug / non-scheduled" },
];

export const expDateList = [
  {
    name: "0-30 days",
    value: "0-30 days",
    apiValue: 29,
  },
  {
    name: "30-60 days",
    value: "30-60 days",
    apiValue: 59,
  },
  {
    name: "60-90 days",
    value: "60-90 days",
    apiValue: 89,
  },
  {
    name: "90-120 days",
    value: "90-120 days",
    apiValue: 119,
  },
];

export const serviceCategoryList = [
  { name: "Boarding", value: "Boarding" },
  { name: "Consulation & General care", value: "Consulation & General care" },
  { name: "Diagnostics", value: "Diagnostics" },
  { name: "In-patient", value: "In-patient" },
  { name: "Procedure", value: "Procedure" },
  { name: "Surgery", value: "Surgery" },
];

export const productMeasurementUnit = [
  { name: "Ampoule", value: "Ampoule" },
  { name: "Blister", value: "Blister" },
  { name: "Bottle", value: "Bottle" },
  { name: "Box", value: "Box" },
  { name: "Box (10 strips)", value: "Box (10 strips)" },
  { name: "Can", value: "Can" },
  { name: "Chewable Tablet", value: "Chewable Tablet" },
  { name: "Container", value: "Container" },
  { name: "Jar", value: "Jar" },
  { name: "Pack", value: "Pack" },
  { name: "Piece (N)", value: "Piece (N)" },
  { name: "Pipette", value: "Pipette" },
  { name: "Sachet", value: "Sachet" },
  { name: "Strip", value: "Strip" },
  { name: "Syringe", value: "Syringe" },
  { name: "Tube", value: "Tube" },
  { name: "Vial", value: "Vial" },
];

export const productSubMeasurementUnit = [
  { name: "20g ", value: "20g " },
  { name: "1 mL ampoule", value: "1 mL ampoule" },
  { name: "5 ml", value: "5 ml" },
  { name: "5 mL vial", value: "5 mL vial" },
  { name: "6 ml vial", value: "6 ml vial" },
  { name: "Ampoulea", value: "Ampoulea" },
  { name: "Caplet", value: "Caplet" },
  { name: "Capsule", value: "Capsule" },
  { name: "Dose", value: "Dose" },
  { name: "Gram", value: "Gram" },
  { name: "Grams", value: "Grams" },
  { name: "Gram (gm)", value: "Gram (gm)" },
  { name: "Grams (g)", value: "Grams (g)" },
  { name: "ml", value: "ml" },
  { name: "mL", value: "mL" },
  { name: "Milliliter (ml)", value: "Milliliter (ml)" },
  { name: "Milliliters", value: "Milliliters" },
  { name: "Milliliters (ml)", value: "Milliliters (ml)" },
  { name: "mL (Milliliters)", value: "mL (Milliliters)" },
  { name: "Patch", value: "Patch" },
  { name: "Prefilled syringe", value: "Prefilled syringe" },
  { name: "Single Tablet", value: "Single Tablet" },
  { name: "Soft Chew", value: "Soft Chew" },
  { name: "Softgel Capsule", value: "Softgel Capsule" },
  { name: "Strip of tablets", value: "Strip of tablets" },
  { name: "Tablet", value: "Tablet" },
  { name: "Vial", value: "Vial" },
];

export const natureList = [
  { name: "Capsule", value: "Capsule" },
  { name: "Eye Drops", value: "Eye Drops" },
  { name: "Injection", value: "Injection" },
  { name: "Liquid Suspension", value: "Liquid Suspension" },
  { name: "Oral solution", value: "Oral solution" },
  { name: "Paste", value: "Paste" },
  { name: "Powder", value: "Powder" },
  { name: "Syrup", value: "Syrup" },
  { name: "Tablet", value: "Tablet" },
];

export const locationList = [
  { name: "Clinic OP", value: "Clinic OP" },
  { name: "Clinic IP", value: "Clinic IP" },
  { name: "Pharmacy", value: "Pharmacy" },
  { name: "Pet Shop", value: "Pet Shop" },
  { name: "Lab", value: "Lab" },
];

export const paymentSourceTypes = [
  { name: "All", value: "All", apiValue: "All" },
  {
    name: "Clinic",
    value: "Clinic",
    apiValue: "Clinic",
    reportValue: "clinic",
  },
  {
    name: "Pet Shop",
    value: "Pet Shop",
    apiValue: "PETSHOP",
    reportValue: "petshop",
  },
  {
    name: "Pharmacy",
    value: "Pharmacy",
    apiValue: "Pharmacy",
    reportValue: "pharmacy",
  },
];

export const appointmentList = [
  { label: "Immediate", value: "Immediate" },
  { label: "Later", value: "Later" },
];

export const appointmentLaterList = [{ label: "Later", value: "Later" }];

export const prdctServceList = [
  { name: "Product", value: "Product" },
  { name: "Service", value: "Service" },
];

export const routeList = [
  { name: "Ear Drops", value: "Ear Drops" },
  { name: "Eye Drops", value: "Eye Drops" },
  { name: "Intramuscular", value: "Intramuscular" },
  { name: "Intravenous", value: "Intravenous" },
  { name: "Nasal Drops", value: "Nasal Drops" },
  { name: "Oral", value: "Oral" },
  { name: "Subcutaneous", value: "Subcutaneous" },
  { name: "Topical", value: "Topical" },
];

export const stockExpireDateList = [
  { name: "Less than 30 days", value: "Less than 30 days" },
  { name: "Less than 90 days", value: "Less than 90 days" },
  { name: "Less than 180 days", value: "Less than 180 days" },
];

export const stockQuantityList = [
  { name: "Less than 10", value: "Less than 10" },
  { name: "Less than 50", value: "Less than 50" },
];

export const discountTypes = [
  { name: "Percentage", value: "Percentage" },
  { name: "Price", value: "Price" },
];

export const billTypes = [
  { name: "OTC", value: "OTC" },
  { name: "Pet Shop", value: "Pet Shop" },
];

export const locationTypes = [
  { name: "Warehouse", value: "Warehouse" },
  { name: "Storage", value: "Storage" },
  // { name: "Consumption", value: "Consumption" },
];

export const locationTypesWOConsum = [
  { name: "Warehouse", value: "Warehouse" },
  { name: "Storage", value: "Storage" },
];

export const locationCategoryList = [
  { name: "At-Home", value: "At-Home" },
  { name: "Clinic", value: "Clinic" },
  { name: "Pharmacy", value: "Pharmacy" },
  { name: "Pet Shop", value: "Pet Shop" },
];

export const facilityTypes = [
  { name: "Consultation Room", value: "ConsultationRoom" },
  { name: "Operation Theatre", value: "OperationTheatre" },
  { name: "Kennel", value: "Kennel" },
  { name: "Bath Bays", value: "BathBays" },
  { name: "Home Kit", value: "HomeKit" },
  { name: "Treatment Area", value: "TreatmentArea" },
  { name: "Devices", value: "Devices" },
  { name: "Others", value: "Others" },
];

export const temperaments = [
  { name: "Anxious", value: "Anxious" },
  { name: "Aggressive", value: "Aggressive" },
  { name: "Calm", value: "Calm" },
  { name: "Friendly", value: "Friendly" },
  { name: "Independent", value: "Independent" },
  { name: "Playful", value: "Playful" },
];

export const bloodGroups = [
  { name: "DEA 1.1", value: "DEA 1.1" },
  { name: "DEA 1.2", value: "DEA 1.2" },
  { name: "DEA 1.3", value: "DEA 1.3" },
  { name: "DEA 3", value: "DEA 3" },
  { name: "DEA 4", value: "DEA 4" },
  { name: "DEA 5", value: "DEA 5" },
  { name: "DEA 7 ", value: "DEA 7 " },
  { name: "Unknown", value: "Unknown" },
];

export const purchaseTypes = [
  { name: "Intrastate", value: "Intrastate" },
  { name: "Interstate", value: "Interstate" },
  { name: "Exempt", value: "Exempt" },
];

export const planTypes = [
  { name: "Single Use", value: "Single Use" },
  { name: "Multi Use", value: "Multi Use" },
];

export const planServiceTypes = [
  { name: "Consultation", value: "Consultation" },
  { name: "Grooming", value: "Grooming" },
  { name: "Others", value: "Others" },
  { name: "Surgery", value: "Surgery" },
  { name: "Vaccination", value: "Vaccination" },
];

export const mealTypes = [
  { name: "", value: "" },
  { name: "After Food", value: "afterFood" },
  { name: "Before Food", value: "beforeFood" },
  { name: "With Food", value: "withFood" },
  { name: "On Empty Stomach", value: "onEmptyStomach" },
];

export const answerTypes = [
  { name: "Checkboxes", value: "checkboxes" },
  { name: "File upload", value: "fileupload" },
  { name: "Multiple Choice", value: "multipleChoice" },
  { name: "Long Text", value: "paragraph" },
  { name: "Short Text", value: "shortAnswer" },
];

export const ServiceTypes = [
  { name: "Medical", value: "Medical" },
  { name: "Non-Medical", value: "Non-Medical" },
];

export const RefundTypes = [
  { name: "Cash", value: "cash" },
  { name: "UPI", value: "upi" },
  { name: "Credit/Debit Card", value: "card" },
];

export const administeredUOMList = [
  // Standard Fallback / Discrete Counts
  { name: "pc(s)", value: "pcs", gstCode: "PCS", globalCode: "PCE" },
  { name: "no(s)", value: "nos", gstCode: "NOS", globalCode: "NPR" },
  { name: "each", value: "each", gstCode: "PCS", globalCode: "EA" },
  { name: "unit(s)", value: "unit", gstCode: "UNT", globalCode: "C62" },

  // Volumes / Liquids
  { name: "ml", value: "ml", gstCode: "MLT", globalCode: "MLT" },
  { name: "L", value: "L", gstCode: "LTR", globalCode: "LTR" },
  { name: "drop(s)", value: "drops", gstCode: "OTH", globalCode: "gtts" },

  // Weights / Masses
  { name: "mcg", value: "mcg", gstCode: "OTH", globalCode: "MC" },
  { name: "mg", value: "mg", gstCode: "OTH", globalCode: "MGM" },
  { name: "g", value: "g", gstCode: "GMS", globalCode: "GRM" },
  { name: "kg", value: "kg", gstCode: "KGS", globalCode: "KGM" },

  // Measurements / Dimensions
  { name: "micron(s)", value: "micron", gstCode: "OTH", globalCode: "4H" },
  { name: "mm", value: "mm", gstCode: "OTH", globalCode: "MMT" },
  { name: "cm", value: "cm", gstCode: "CMS", globalCode: "CMT" },
  { name: "m", value: "m", gstCode: "MTR", globalCode: "MTR" },
  { name: "inch(es)", value: "inches", gstCode: "INC", globalCode: "INH" },

  // Clinical Dosage Forms
  { name: "tab(s)", value: "tab", gstCode: "TBS", globalCode: "TFT" },
  { name: "capsule(s)", value: "capsule", gstCode: "OTH", globalCode: "AV" },
  {
    name: "chewable tab(s)",
    value: "chewable tab",
    gstCode: "TBS",
    globalCode: "TFT",
  },
  { name: "lozenge(s)", value: "lozenge", gstCode: "OTH", globalCode: "loz" },
  { name: "puff(s)", value: "puff", gstCode: "OTH", globalCode: "puff" },
  { name: "dose(s)", value: "dose", gstCode: "OTH", globalCode: "DOSE" },
  {
    name: "injection(s)",
    value: "injection",
    gstCode: "OTH",
    globalCode: "inj",
  },
  {
    name: "application(s)",
    value: "application",
    gstCode: "OTH",
    globalCode: "appl",
  },
  {
    name: "suppository(ies)",
    value: "suppository",
    gstCode: "OTH",
    globalCode: "supp",
  },
  {
    name: "pessary(ies)",
    value: "pessary",
    gstCode: "OTH",
    globalCode: "pess",
  },
  { name: "enema(s)", value: "enema", gstCode: "OTH", globalCode: "enema" },
  { name: "gum(s)", value: "gum", gstCode: "OTH", globalCode: "gum" },
  { name: "implant(s)", value: "implant", gstCode: "OTH", globalCode: "imp" },

  // Primary Medical Packaging & Containment
  { name: "vial(s)", value: "vial", gstCode: "OTH", globalCode: "VI" },
  { name: "ampoule(s)", value: "ampoule", gstCode: "OTH", globalCode: "AM" },
  { name: "respule(s) ", value: "respule", gstCode: "OTH", globalCode: "RE" },
  {
    name: "pre-filled syringe(s)",
    value: "pre-filled syringe",
    gstCode: "OTH",
    globalCode: "pfsyr",
  },
  { name: "syringe(s)", value: "syringe", gstCode: "OTH", globalCode: "syr" },
  { name: "pen(s)", value: "pen", gstCode: "OTH", globalCode: "pen" },
  { name: "tube(s)", value: "tube", gstCode: "TUB", globalCode: "TU" },
  { name: "pipette(s)", value: "pipette", gstCode: "OTH", globalCode: "pip" },
  { name: "patch(es)", value: "patch", gstCode: "OTH", globalCode: "ptch" },
  { name: "plaster(s)", value: "plaster", gstCode: "OTH", globalCode: "plst" },
  { name: "spray(s)", value: "spray", gstCode: "OTH", globalCode: "spry" },
  { name: "pump(s)", value: "pump", gstCode: "OTH", globalCode: "pump" },
  { name: "sachet(s)", value: "sachet", gstCode: "OTH", globalCode: "sach" },
  {
    name: "cartridge(s)",
    value: "cartridge",
    gstCode: "OTH",
    globalCode: "cart",
  },

  // Secondary & Bulk Packaging
  { name: "packet(s)", value: "packet", gstCode: "PAC", globalCode: "PA" },
  { name: "pack(s)", value: "pack", gstCode: "PAC", globalCode: "PK" },
  { name: "box(es)", value: "box", gstCode: "BOX", globalCode: "BX" },
  { name: "bottle(s)", value: "bottle", gstCode: "BTL", globalCode: "BO" },
  { name: "can(s)", value: "can", gstCode: "CAN", globalCode: "CA" },
  { name: "canister(s)", value: "canister", gstCode: "OTH", globalCode: "CI" },
  { name: "jar(s)", value: "jar", gstCode: "OTH", globalCode: "JR" },
  { name: "tin(s)", value: "tin", gstCode: "TIN", globalCode: "TN" },
  { name: "bag(s)", value: "bag", gstCode: "BAG", globalCode: "BG" },
  { name: "pouch(es)", value: "pouch", gstCode: "OTH", globalCode: "PO" },

  // Medical Supplies / Surgical / Miscellaneous
  { name: "strip(s)", value: "strip", gstCode: "OTH", globalCode: "ST" },
  { name: "suture(s)", value: "suture", gstCode: "OTH", globalCode: "sut" },
  { name: "swab(s)", value: "swab", gstCode: "OTH", globalCode: "swab" },
  { name: "wipe(s)", value: "wipe", gstCode: "OTH", globalCode: "wipe" },
  { name: "pad(s)", value: "pad", gstCode: "OTH", globalCode: "pad" },
  { name: "mat(s)", value: "mat", gstCode: "OTH", globalCode: "mat" },
  { name: "slide(s)", value: "slide", gstCode: "OTH", globalCode: "sld" },
  { name: "plate(s)", value: "plate", gstCode: "OTH", globalCode: "plt" },
  { name: "pair(s)", value: "pair", gstCode: "PRS", globalCode: "PR" },
  { name: "roll(s)", value: "roll", gstCode: "ROL", globalCode: "RO" },
  { name: "set(s)", value: "set", gstCode: "SET", globalCode: "SET" },
  { name: "sheet(s)", value: "sheet", gstCode: "OTH", globalCode: "STH" },
  { name: "kit(s)", value: "kit", gstCode: "SET", globalCode: "KT" },
  { name: "device(s)", value: "device", gstCode: "OTH", globalCode: "dev" },
  { name: "test(s)", value: "test", gstCode: "OTH", globalCode: "test" },

  // Additional Surgical & Lab Supplies
  { name: "tip(s)", value: "tip", gstCode: "OTH", globalCode: "C62" },
  {
    name: "vacutainer(s)",
    value: "vacutainer",
    gstCode: "OTH",
    globalCode: "VI",
  },
  { name: "brush(es)", value: "brush", gstCode: "OTH", globalCode: "PCE" },
  { name: "disc(s)", value: "disc", gstCode: "OTH", globalCode: "PCE" },
  { name: "blade(s)", value: "blade", gstCode: "OTH", globalCode: "PCE" },

  // Veterinary Specific
  { name: "treat(s)", value: "treat", gstCode: "OTH", globalCode: "trt" },
  { name: "chew(s)", value: "chew", gstCode: "OTH", globalCode: "chew" },
  { name: "scoop(s)", value: "scoop", gstCode: "OTH", globalCode: "scp" },
  { name: "cup(s)", value: "cup", gstCode: "OTH", globalCode: "cup" },
  { name: "stick(s)", value: "stick", gstCode: "OTH", globalCode: "stk" },
  { name: "bar(s)", value: "bar", gstCode: "OTH", globalCode: "bar" },
];

export const dosageTypes = [
  { name: "BSA", value: "BSA" },
  { name: "Fixed", value: "Fixed" },
  { name: "Weight-Based", value: "Weight-Based" },
];

export const appointmentStatusList = [
  { name: "All", value: "All" },
  { name: "Upcoming", value: "Upcoming" },
  { name: "Checked-in", value: "Checked-in" },
  { name: "In Transit", value: "In Transit" },
  { name: "Consultation", value: "Consultation" },
  { name: "Billing", value: "Billing" },
  { name: "Completed", value: "Completed" },
  { name: "Cancelled", value: "Cancelled" },
];

export const physicalStatusList = [
  { name: "Upcoming", value: "Upcoming" },
  { name: "Checked-in", value: "Checked-in" },
  { name: "Consultation", value: "Consultation" },
  { name: "Billing", value: "Billing" },
  { name: "Completed", value: "Completed" },
  { name: "No Show", value: "noshow" },
];

export const homeVisitStatusList = [
  { name: "Upcoming", value: "Upcoming" },
  { name: "In Transit", value: "In Transit" },
  { name: "Consultation", value: "Consultation" },
  { name: "Billing", value: "Billing" },
  { name: "Completed", value: "Completed" },
];

export const virtualStatusList = [
  { name: "Upcoming", value: "Upcoming" },
  { name: "Consultation", value: "Consultation" },
  { name: "Completed", value: "Completed" },
];

export const sampleTypes = [
  { name: "Blood", value: "BLOOD" },
  { name: "Serum", value: "SERUM" },
  { name: "Plasma", value: "PLASMA" },
  { name: "Urine", value: "URINE" },
  { name: "Feces", value: "FECES" },
  { name: "Swab", value: "SWAB" },
  { name: "Skin Scraping", value: "SKIN_SCRAPING" },
  { name: "Cytology Smear", value: "CYTOLOGY" },
  { name: "Fine Needle Aspirate (FNA)", value: "FINE_NEEDLE_ASPIRATE" },
  { name: "Biopsy", value: "BIOPSY" },
  { name: "Hair", value: "HAIR" },
  { name: "Nail Clipping", value: "NAIL" },
  { name: "Ear Swab", value: "EAR_SWAB" },
  { name: "Vaginal Smear", value: "VAGINAL_SMEAR" },
  { name: "Semen", value: "SEMEN" },
  { name: "Milk", value: "MILK" },
  { name: "Abdominal Fluid", value: "ABDOMINAL_FLUID" },
  { name: "Thoracic Fluid", value: "THORACIC_FLUID" },
  { name: "Cerebrospinal Fluid (CSF)", value: "CSF" },
  { name: "Joint Fluid", value: "JOINT_FLUID" },
  { name: "Tracheal Wash", value: "TRACHEAL_WASH" },
  { name: "Bronchoalveolar Lavage (BAL)", value: "BRONCHOALVEOLAR_LAVAGE" },
  { name: "Nasal Discharge", value: "NASAL_DISCHARGE" },
  { name: "Oral Swab", value: "ORAL_SWAB" },
  { name: "Tissue Sample", value: "TISSUE" },
  { name: "Sputum", value: "SPUTUM" },
  { name: "Bile", value: "BILE" },
  { name: "Gastric Contents", value: "GASTRIC_CONTENTS" },
  { name: "Wound Exudate", value: "WOUND_EXUDATE" },
  { name: "Bone Marrow Aspirate", value: "Bone Marrow Aspirate" },
  { name: "Cerebrospinal Fluid (CSF)", value: "Cerebrospinal Fluid (CSF)" },
];

export const doneAtList = [
  { name: "In-house", value: "In-house" },
  { name: "External", value: "External" },
];

export const modalities = [
  { name: "X-Ray (Radiograph)", value: "XRAY" },
  { name: "Ultrasound (Sonography)", value: "US" },
  { name: "Doppler Ultrasound", value: "DOPPLER" },
  { name: "Echocardiography", value: "ECHO" },
  { name: "Dental Radiograph", value: "DENTAL_XRAY" },
  { name: "CT Scan (Computed Tomography)", value: "CT" },
  { name: "MRI (Magnetic Resonance Imaging)", value: "MRI" },
  { name: "Fluoroscopy", value: "FLUORO" },
  { name: "Contrast Radiography", value: "CONTRAST_XRAY" },
  { name: "Thermography", value: "THERMO" },
  { name: "Nuclear Scintigraphy", value: "SCINT" },
  { name: "Endoscopy", value: "ENDO" },
  { name: "Laparoscopy", value: "LAP" },
  { name: "Arthroscopy", value: "ARTHRO" },
  { name: "Video Otoscopy", value: "VID_OTOSCOPY" },
];

export const regionList = [
  { name: "SKULL", value: "SKULL", modality: "XRAY" },
  { name: "THORAX", value: "THORAX", modality: "XRAY" },
  { name: "ABDOMEN", value: "ABDOMEN", modality: "XRAY" },
  { name: "SPINE", value: "SPINE", modality: "XRAY" },
  { name: "LIMBS", value: "LIMBS", modality: "XRAY" },
  { name: "JOINTS", value: "JOINTS", modality: "XRAY" },
  { name: "TAIL", value: "TAIL", modality: "XRAY" },
  { name: "ABDOMEN", value: "ABDOMEN", modality: "US" },
  { name: "LIVER", value: "LIVER", modality: "US" },
  { name: "KIDNEYS", value: "KIDNEYS", modality: "US" },
  { name: "SPLEEN", value: "SPLEEN", modality: "US" },
  { name: "BLADDER", value: "BLADDER", modality: "US" },
  { name: "REPRODUCTIVE", value: "REPRODUCTIVE", modality: "US" },
  { name: "GI", value: "GI", modality: "US" },
  { name: "JOINTS", value: "JOINTS", modality: "US" },
  { name: "Eyes", value: "EYES", modality: "US" },
  { name: "HEART", value: "HEART", modality: "DOPPLER" },
  { name: "LIVER", value: "LIVER", modality: "DOPPLER" },
  { name: "KIDNEYS", value: "KIDNEYS", modality: "DOPPLER" },
  { name: "HEART", value: "HEART", modality: "ECHO" },
  { name: "SKULL", value: "SKULL", modality: "CT" },
  { name: "BRAIN", value: "BRAIN", modality: "CT" },
  { name: "THORAX", value: "THORAX", modality: "CT" },
  { name: "ABDOMEN", value: "ABDOMEN", modality: "CT" },
  { name: "SPINE", value: "SPINE", modality: "CT" },
  { name: "JOINTS", value: "JOINTS", modality: "CT" },
  { name: "Whole Body", value: "WHOLE BODY", modality: "CT" },
  { name: "BRAIN", value: "BRAIN", modality: "MRI" },
  { name: "SPINE", value: "SPINE", modality: "MRI" },
  { name: "JOINTS", value: "JOINTS", modality: "MRI" },
  { name: "TEETH", value: "TEETH", modality: "DENTAL_XRAY" },
  { name: "SKULL", value: "SKULL", modality: "DENTAL_XRAY" },
  { name: "GI", value: "GI", modality: "CONTRAST_XRAY" },
  { name: "BLADDER", value: "BLADDER", modality: "CONTRAST_XRAY" },
  { name: "SPINE", value: "SPINE", modality: "CONTRAST_XRAY" },
  { name: "GI", value: "GI", modality: "FLUORO" },
  { name: "TRACHEA", value: "TRACHEA", modality: "FLUORO" },
  { name: "ESOPHAGUS", value: "ESOPHAGUS", modality: "FLUORO" },
  { name: "WHOLE_BODY", value: "WHOLE_BODY", modality: "THERMO" },
  { name: "LIMBS", value: "LIMBS", modality: "THERMO" },
  { name: "SPINE", value: "SPINE", modality: "THERMO" },
  { name: "WHOLE_BODY", value: "WHOLE_BODY", modality: "SCINT" },
  { name: "LIMBS", value: "LIMBS", modality: "SCINT" },
  { name: "BONE", value: "BONE", modality: "SCINT" },
  { name: "GI", value: "GI", modality: "ENDO" },
  { name: "RESPIRATORY", value: "RESPIRATORY", modality: "ENDO" },
  { name: "ESOPHAGUS", value: "ESOPHAGUS", modality: "ENDO" },
  { name: "Bladder", value: "BLADDER", modality: "ENDO" },
  { name: "Ears", value: "EARS", modality: "ENDO" },
  { name: "ABDOMEN", value: "ABDOMEN", modality: "LAP" },
  { name: "LIVER", value: "LIVER", modality: "LAP" },
  { name: "REPRODUCTIVE", value: "REPRODUCTIVE", modality: "LAP" },
  { name: "JOINTS", value: "JOINTS", modality: "ARTHRO" },
  { name: "EARS", value: "EARS", modality: "VID_OTOSCOPY" },
];

export const devices = [
  { name: "MRI", value: "MRI" },
  { name: "CT Scan", value: "CT Scan" },
];

export const presFilters = [
  // { name: "All", value: "All" },
  { name: "Active", value: "Active" },
  { name: "Discontinued", value: "Discontinued" },
];

export const diagnosticTypes = [
  { name: "Lab", value: "Lab" },
  { name: "Radiology", value: "Radiology" },
];

export const priorityList = [
  { name: "Routine", value: "Routine" },
  { name: "Urgent", value: "Urgent" },
  { name: "Stat", value: "Stat" },
];

export const diagStatusList = [
  { name: "In Progress", value: "In Progress" },
  { name: "Pending Approval", value: "Pending Approval" },
  { name: "Pending Review", value: "Pending Review" },
  { name: "Completed", value: "Completed" },
  { name: "Cancelled", value: "Cancelled" },
];

export const downloadTypeList = [
  { name: "Vaccine history", value: "Vaccine certificate" },
  { name: "Travel certificate", value: "Travel certificate" },
  { name: "Fitness certificate", value: "Fitness certificate" },
];

export const documentTypes = [
  { name: "Form", value: "Form" },
  { name: "Certificate", value: "Cert" },
];

export const workbookStatusList = [
  { name: "Acute", value: "Acute" },
  { name: "Ongoing", value: "Ongoing" },
  { name: "Chronic", value: "Chronic" },
  { name: "Resolved", value: "Resolved" },
  // { name: "Active", value: "Active" },
  // { name: "Under Treatment", value: "Under Treatment" },
  // { name: "Monitoring", value: "Monitoring" },
  // { name: "Resolved", value: "Resolved" },
  // { name: "Inactive", value: "Inactive" },
];

export const radioYesNoList = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

export const statusDrop = [
  { name: "Completed", value: true },
  { name: "Not Done", value: false },
];

export const pharmacyStatusDrop = [
  { name: "Issued", value: true },
  { name: "Rejected", value: false },
];

export const petOwnershipTypes = [
  { label: "Household Pet", value: "Household" },
  { label: "Rescue/Shelter", value: "Rescue" },
];

export const petOwnershipTypesForDrop = [
  { name: "Household Pet", value: "Household" },
  { name: "Rescue/Shelter", value: "Rescue" },
];

export const oldIssueList = [
  { name: "Emergency", value: "Emergency" },
  // { name: "Follow Up", value: "FollowUp" },
  { name: "Ear", value: "Ear" },
  { name: "Eye", value: "Eye" },
  { name: "Gastrointestinal", value: "Gastrointestinal" },
  { name: "General", value: "General" },
  { name: "Mobility", value: "Mobility" },
  { name: "Mouth", value: "Mouth" },
  { name: "Respiratory", value: "Respiratory" },
  { name: "Urinary", value: "Urinary" },
  { name: "Skin & Coat", value: "Skin" },
  { name: "Others", value: "Others" },
];

export const petOwnershipTypeList = [
  { name: "All", value: "all" },
  { name: "Household Pet", value: "household" },
  { name: "Rescue/Shelter", value: "rescue" },
];

export const requestTypeList = [
  { name: "Consumption", value: "Consumption" },
  { name: "Internal Transfer", value: "Internal Transfer" },
  { name: "External Transfer", value: "External Transfer" },
];

export const pointOfSalesAllCategoryList = [
  { name: "Deworming", value: "Deworming" },
  { name: "Flea & Tick Treatment", value: "Flea & Tick Treatment" },
  { name: "Other Parasite Treatment", value: "Other Parasite Treatment" },
  { name: "Medication", value: "Medication" },
  { name: "Fluid Therapy", value: "Fluid Therapy" },
  { name: "Diet", value: "Diet" },
  { name: "Nutrition & Supplements", value: "Nutrition & Supplements" },
  { name: "OTC Products", value: "OTC Products" },
  { name: "Grooming & Hygiene Care", value: "Grooming & Hygiene Care" },
  { name: "Accessories & Toys", value: "Accessories & Toys" },
  { name: "Pet Supplies", value: "Pet Supplies" },
];

export const pointOfSalesPharmacyCategoryList = [
  { name: "Deworming", value: "Deworming" },
  { name: "Flea & Tick Treatment", value: "Flea & Tick Treatment" },
  { name: "Other Parasite Treatment", value: "Other Parasite Treatment" },
  { name: "Medication", value: "Medication" },
  { name: "Fluid Therapy", value: "Fluid Therapy" },
  { name: "Diet", value: "Diet" },
  { name: "Nutrition & Supplements", value: "Nutrition & Supplements" },
  { name: "Grooming & Hygiene Care", value: "Grooming & Hygiene Care" },
];

export const pointOfSalesPetShopCategoryList = [
  { name: "OTC Products", value: "OTC Products" },
  { name: "Grooming & Hygiene Care", value: "Grooming & Hygiene Care" },
  { name: "Accessories & Toys", value: "Accessories & Toys" },
  { name: "Pet Supplies", value: "Pet Supplies" },
];

export const pointOfSalesLocationList = [
  { name: "All", value: "All" },
  { name: "Pharmacy", value: "Pharmacy" },
  { name: "Pet Shop", value: "Pet Shop" },
];

export const numberOfDaysList = [
  { name: "Duration", value: "Duration" },
  { name: "Till Discharge", value: "Till Discharge" },
];

export const incDecList = [
  { name: "Increase", value: "Increase" },
  { name: "Decrease", value: "Decrease" },
];

export const visitTypes = [
  { name: "Follow Up", value: "Follow-up" },
  { name: "New", value: "New" },
];

export const scheduleImmediateList = [
  { name: "Immediate", value: true },
  { name: "Scheduled", value: false },
];

export const vetPerformStatus = [
  { name: "Completed", value: "Completed" },
  { name: "Noshow", value: "Noshow" },
  { name: "Cancelled", value: "Cancelled" },
];

export const reportPetTypes = [
  { name: "Existing", value: "Existing" },
  { name: "New", value: "New" },
];

export const stockMovementTypes = [
  { name: "Fast Moving", value: "fast-moving" },
  { name: "Normal", value: "normal" },
  { name: "Slow", value: "slow-moving" },
];

export const expiryStatusList = [
  { name: "Attention Required", value: "Attention Required" },
  { name: "Critical", value: "Critical" },
  { name: "Near Expiry", value: "Near Expiry" },
];

export const returnReasons = [
  { name: "Defective", value: "Defective" },
  { name: "Wrong Item", value: "Wrong Item" },
  { name: "Expired", value: "Expired" },
  { name: "Other", value: "Other" },
];

export const cancelReasons = [
  { name: "Duplicate Invoice", value: "Duplicate Invoice" },
  { name: "Incorrect Billing", value: "Incorrect Billing" },
  { name: "Incorrect Pricing", value: "Incorrect Pricing" },
  { name: "Wrong Customer/Pet Selected", value: "Wrong Customer/Pet Selected" },
  {
    name: "Items/Services Added by Mistake",
    value: "Items/Services Added by Mistake",
  },
  { name: "Items/Services Not Rendered", value: "Items/Services Not Rendered" },
  { name: "Consultation Cancelled", value: "Consultation Cancelled" },
  { name: "Payment Entry Error", value: "Payment Entry Error" },
  {
    name: "Customer Declined Treatment/Purchase",
    value: "Customer Declined Treatment/Purchase",
  },
  { name: "Invoice Recreated", value: "Invoice Recreated" },
  { name: "System/Data Entry Error", value: "System/Data Entry Error" },
  { name: "Test/Demo Invoice", value: "Test/Demo Invoice" },
  { name: "Others", value: "Others" },
];

export const diagVetStatusList = [
  {
    name: "Send for clinician’s review",
    value: "Pending Review",
  },
  { name: "Pending patient review", value: "Patient Review" },
  { name: "Completed", value: "Completed" },
];

export const diagOtherStatusList = [
  {
    name: "Send for clinician’s review",
    value: "Pending Review",
  },
];

export const billAsForBillingHistory = [
  { name: "Clinic", value: "Clinic" },
  { name: "Pharmacy", value: "Pharmacy" },
  { name: "Pet Shop", value: "Pet Shop" },
];

export const diagTemplateTypes = [
  { name: "Parameter", value: "parameter" },
  { name: "Report", value: "report" },
];

export const invoiceTypes = [
  { name: "All", value: "All" },
  { name: "Appointment", value: "Appointment" },
  { name: "POS", value: "POS" },
];

export const collectionReportTypes = [
  { label: "All", value: "All" },
  { label: "Payment Collection", value: "Revenue Report" },
  {
    label: "Credits Collection Report",
    value: "Credits Collection Report",
  },
  {
    label: "Credits Usage Report",
    value: "Credits Usage Report",
  },
  { label: "Refunds Report", value: "Refunds Report" },
];

export const collectionReportRanges = [
  { label: "Today", value: "Today" },
  { label: "Yesterday", value: "Yesterday" },
  { label: "Week", value: "Week" },
  { label: "Month", value: "Month" },
  { label: "Custom", value: "Custom" },
];

export const transactionTypeList = [
  { name: "All", value: "all" },
  { name: "Sales", value: "SALE" },
  { name: "Purchases", value: "PURCHASE" },
  { name: "Adjustments", value: "STOCK_ADJUSTMENT" },
  { name: "Returns", value: "SALES_RETURN" }, //PURCHASE_RETURN
];

export const nextDueTypes = [
  { name: "day(s)", value: "day" },
  { name: "week(s)", value: "week" },
  { name: "month(s)", value: "month" },
  { name: "year(s)", value: "year" },
];
